export default {
  masterChef: {
    97: '0x010B149BdDdbBA823C255105cBDC4eeb5b2b5A2d',
    56: '0xa68f3bcf49b1Fa33a53d0e442673fca9c52Aa9E5',
  },
  wbnb: {
    97: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    56: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0xae11C5B5f29A6a25e955F0CB8ddCc416f522AF5C',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0x41e9628e9911a1aa80aedd68822bb8d48c12d5be',
  },
  eth: {
    56: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
    97: '',
  },
  usdc: {
    56: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
    97: '0x9DA314B220d03569642Bbe832CF5b60Bdc16DEe1',
  },
  usdt: {
    56: '0x55d398326f99059ff775485246999027b3197955',
    97: '0x8b3aaacF305e6c4E57B3905608654f3691878cee',
  },
  dai: {
    56: '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
    97: '0x231878a07BbBd74D93F7C3a0eCc7CaB641552667',
  },
}
